import { DateTimeFormatter } from '@js-joda/core';

import { useTimesheetStore } from '#/shared/stores/timesheetStore';

export function TimesheetInfo() {
  const timesheet = useTimesheetStore(state => state.timesheet);

  if (!timesheet) {
    return null;
  }

  const { weekEnding, department, doctorName, hospitalName } = timesheet;

  return (
    <>
      <div className="py-8">
        <h3 className="text-14 block font-600">Doctor's name</h3>
        <p className="text-16">{doctorName}</p>
      </div>
      <div className="py-8">
        <h3 className="text-14 block font-600">Hospital’s name</h3>
        <p className="text-16">{hospitalName}</p>
      </div>
      <div className="py-8">
        <h3 className="text-14 block font-600">Week ending</h3>
        <p className="text-16">{weekEnding.format(DateTimeFormatter.ofPattern('dd/MM/yyyy'))}</p>
      </div>
      <div className="py-8">
        <h3 className="text-14 block font-600">Department</h3>
        <p className="text-16">{department ?? <span className="text-on-surface-variant">None entered</span>}</p>
      </div>
    </>
  );
}
